import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { PagedRequesterTokens, RequesterToken } from 'stores/RequesterTokenStore';
import { ActionIcon, DeleteIcon, EditIcon } from 'components/Icon';
import { DefaultCopyToClipboard } from 'components/CopyToClipboard';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  requesterTokens: PagedRequesterTokens,
  editRequesterTokenHandler: (feature: RequesterToken) => Promise<void>,
  deleteRequesterTokenHandler: (feature: RequesterToken) => Promise<void>,
}
export const RequesterTokenList: React.FC<Props> = observer(({requesterTokens, editRequesterTokenHandler, deleteRequesterTokenHandler}: Props) =>
{
  const { uiStore } = useStore();

  return (
    <table>
      <thead>
        <tr>
          <th>
            {uiStore.labels.pages.audience.requesterTokensTable.tokenColumnName}
            <SimpleInlineHelp>{uiStore.labels.help.audience.requester_tokens.token.about}</SimpleInlineHelp>
          </th>
          <th>{uiStore.labels.pages.audience.requesterTokensTable.requesterColumnName}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          requesterTokens.data?.map(x =>
            <tr key={x.token}>
              <td>
                <Link title={uiStore.labels.pages.audience.viewDetailsOfRequesterToken.apply({requesterToken: x.token})}
                      to={{pathname: paths.buildRequesterTokenViewPath(x.token || ''), state: { isCancelRequired: true }}}>
                  {x.token}
                </Link>
                <DefaultCopyToClipboard text={x.token} />
              </td>
              <td>{x.requester?.name}</td>
              <td className="actions">
                <ActionIcon tip={uiStore.labels.pages.audience.editRequesterToken.apply({requesterToken: x.token})} action={async () => await editRequesterTokenHandler(x)}><EditIcon /></ActionIcon>
                <ActionIcon tip={uiStore.labels.pages.audience.deleteRequesterToken.apply({requesterToken: x.token})} action={async () => await deleteRequesterTokenHandler(x)}><DeleteIcon /></ActionIcon>
              </td>
            </tr>)
        }
      </tbody>
    </table>
  );
});